module.exports = __webpack_public_path__ + "static/media/Akemi_3132.f838769d.jpg";